import { Container, makeStyles } from "@material-ui/core";

import { ContentSection } from "../application/ContentSection";
import { TitleHeader } from "../components/page/TitleHeader";
import { YourLevelFullCard } from "./your-level/YourLevelFullCard";
import { Section } from "../components/section/Section";
import { GreenButton, VerticalButtons } from "../components/new-button";
import { GardenerDocument } from "../gardener/gardener.model";

const useStyles = makeStyles({
    container: {
        "& > *": {
            marginBottom: "32px",
        },
    
        "& > *:last-child": {
            marginBottom: 0,
        },
    },
});

export interface CooperationPageProps {
    gardener: GardenerDocument;
    goToAgreementPage: () => void;
}

export const CooperationPage = (props: CooperationPageProps) => {
    const classes = useStyles();
    const { gardener, goToAgreementPage } = props;

    return (
        <>
            <TitleHeader>Vores samarbejde</TitleHeader>

            <ContentSection>
                <Container maxWidth="md" disableGutters className={classes.container}>

                    <Section>
                        <YourLevelFullCard gardener={gardener} />

                        <VerticalButtons>
                            <GreenButton onClick={goToAgreementPage}>Læs samarbejdsaftale</GreenButton>
                        </VerticalButtons>

                    </Section>


                </Container>
            </ContentSection>
        </>
    );
};
